export const PAYMENTS = [
    { label: 'Наличные', value: 1 },
    { label: 'По карте', value: 2 },
    { label: 'Полис ДМС', value: 3 }
];
